'use strict'

hostCom.send('awe:ping')

// this code runs only once, and can be discarded afterwards.
// That should be the case after the initWidget event has been processed.
void function () {
  const cpntConditions = {} // template-defined functions that condition component loading

  // fetches template and inits Vue app
  async function start(e) {
    e.params.perf.switch = Date.now() - e.switchStart
    performance.mark('app-start')

    const legacyCustomStyle = {},
      legacyCustomStyleValues = {},
      customStyleMapping = {}

    try{
      // check again safeframe for media widgets when not detected
      if (e.params.media && !e.params.withSafeFrame)
        detectSafeFrame()

      const defaultTemplates = ['swnDefault', 'lp-legacy']
      // get template
      // set operator to special value if default template is selected - which isn't linked to a specific operator
      const operator = defaultTemplates.includes(e.params.template) || /^(default)?_/.test(e.params.template) ? 'default' : e.wtbConf.operatorId,
        templateName = e.params.template,
        tmplPath = `${operator}/${templateName}`

      performance.mark('template-start')
      const res = await fetch(`../../../templates/${tmplPath}/template.html`)
      performance.measure('template', 'template-start')

      let hostStyle = '';
      const scripts = []; // urls for template scripts
      const parameters = e.params
      const remoteConfig = e.wtbConf.widgetclientparams?.params || {}

      if (parameters.fileProtocol)
        hostCom.allowLaxTarget()

      if (res.status != 200) {
        throw new Error(`template not found at /templates/${tmplPath}/template.html`)
      }

      // get template as text & do some manipulations: extract scripts, stylesheets and parameters.
      // remove scripts from template and add them dynamically (vue doesn't parse script tags in template)

      // First, remove plugin scripts, as they must run before app instanciation.
      let template = (await res.text()).replace(/<script\s*mixin>((\s|.)*?)<\/script>/g, (match, content) => {
        insertScript(content, null)

        return ''
      })

      // once we've defined the necessary plugins, instanciate the app.
      window.aweInstance = Vue.createApp(appDefinition)

      // remove external scripts
      template = template.replace(/<script src="(.*?)"(?:\s+integrity="(.*?)"\s*)?><\/script>/g, (match, url, integrityHash) => {
        scripts.push({ type: 'url', value: url, integrity: integrityHash })

        return ''
      })
      // remove inline scripts
        .replace(/<script\s*(before-mount|tmpl-init)?>((\s|.)*?)<\/script>/g, (match, attribute, content) => {
          // scripts tagged with before-mount or tmpl-init are immediately inserted
          if (attribute === 'tmpl-init')
            loadConditions(content)
          else if (attribute === 'before-mount')
            insertScript(content, null, null)
          else
            scripts.push({ type: 'inline', value: content })

          return ''
        })
      // look for container style element and extract it
        .replace(/<host-style>((\s|.)*?)<\/host-style>/, (match, style) => {
          hostStyle = style.trim()

          return ''
        })
      // look for inline style tags and extract them.
        .replace(/<style>((\s|.)*?)<\/style>/g , (match, style) => {
          const nd = document.createElement('style')
          nd.innerHTML = style
          document.head.appendChild(nd)

          return ''
        })
      // look for container custom style element and extract it
        .replace(/<style-mapping>((\s|.)*?)<\/style-mapping>/, (match, style) => {

          const customPropParser = /([\w-\d]+) *: *(--[\w\d-_]+\b)(?: (.+))?$/
          style.trim().split('\n').forEach(line => {
          // check if line matches the custom property mapping
            const customPropMatch = line.match(customPropParser)

            if (customPropMatch) {
              const optName = customPropMatch[1],
                customProp = customPropMatch[2],
                ctnr = customPropMatch[3]
              customStyleMapping[optName] = [customProp, ctnr]
            }
            else{
            // line uses the legacy mapping
              const [style, selectors] = line.split(/:(.+)/)
              if (!selectors) return

              const [propName, cssProp] = style.trim().split('/') // separate property name from the actual css property it impacts
              legacyCustomStyle[propName] = selectors.trim()
              legacyCustomStyleValues[propName] = cssProp || ''
            }
          })

          return ''
        })
      // parameters tag contains additional configuration options. if provided, they overwrite any value provided by the loader.
        .replace(/<parameters ([^>]+)><\/parameters>/, (match, attrs) => {
          attrs.match(/[\w-]+="[^"]*"/gi).forEach(attribute => {
            let name, val
            [name, val] = attribute.split('=')
            name = Utils.toCamelCase(name)
            val = val.substring(1, val.length - 1) // remove the surrounding quotes

            // assignment is done differently, depending on expected type
            switch(name) {
              case 'hideHostScroll':
              case 'hasPrices':
              case 'customTrackingOldNaming':
              case 'productPagination':
                parameters[name] = val.toLowerCase() === 'true'
                break
              case 'freeSize':
              case 'fixedSize':
                parameters.freeSize = true // the attribute being present means it's true, no value needed
                break
              case 'delayGeolocation':
                parameters.delayGeolocation = true // the attribute being present means it's true, no value needed
                break
              default: // default: value is a string, taken as-is
                parameters[name] = val.trim()
            }
          })

          return ''
        })

      if (parameters.debug)
        template += '<awe-logger ref="logger"></awe-logger>'

      // finds which components are needed and load them.
      const components = findComponents(template, parameters, remoteConfig)
      const p = loadComponents(components)
      registerComponents() // register default components while loading the dynamic ones

      // send style to host, even if not defined. This message is used as a signal to show widget and custom buttons.
      // IE does not apply styles if the string is not cleaned (no newlines, no multiple spaces)
      hostCom.send('awe:host-style', { style: hostStyle.replace(/\s+/g, ' ') })

      // wait for component scripts to load before mounting app.
      // insert template in DOM after the wait. Otherwise we see the ugly raw template for the duration of components load time.
      await p

      registerComponents() // register dynamic components

      // insert template & mount app
      document.getElementById('app-ctnr').innerHTML = template
      aweInstance.config.compilerOptions.whitespace = 'condense'

      // global error handler, for all vue-related errors (https://vuejs.org/api/application.html#app-config-errorhandler)
      // caught errors are the ones happening in Vue render function, watchers, lifecycle hooks, event handlers, v-on listeners.
      aweInstance.config.errorHandler = function (err, vm, info) {
        console.error(`Error: ${err.message}`, vm, info)
        Tracker.log('error', { msg: err.message, stack: err.stack, info: info })
      }

      aweInstance.config.warnHandler = (msg, instance, trace) => {
        console.warn('Vue warning:', msg, trace)
      }

      performance.mark('vue-mount-start')
      window.app = aweInstance.mount('#app-root')
      performance.measure('vue-mount', 'vue-mount-start')

      app.legacyCustomStyle = legacyCustomStyle
      app.legacyCustomStyleValues = legacyCustomStyleValues
      app.customStyleMapping = customStyleMapping
      parameters.perf.mount = performance.getEntriesByName('vue-mount', 'measure')[0].duration
      parameters.perf.template = performance.getEntriesByName('template', 'measure')[0].duration

      // wait for app to mount before loading additional template scripts
      for (let i = 0; i < scripts.length; i++) {
        switch(scripts[i].type) {
          case 'url':
            insertScript(null, scripts[i].value, scripts[i].integrity)
            break
          case 'inline':
            insertScript(scripts[i].value, null)
            break
        }
      }

      parameters.templatePath = tmplPath
      app.init(parameters, e.wtbConf)

      const buildNd = document.querySelector('meta[name="build"]')
      if (buildNd)
        hostCom.send('awe:templateBuild', { name: templateName, build: buildNd.getAttribute('content') })
    }
    catch(err) {
      console.error(err)
    }
  }

  // inserts script node, setting either the content or the src attribute
  function insertScript(content, src, integrity) {
    const nd = document.createElement('script')

    if (content)
      nd.innerHTML = content
    else if (src) {
      nd.src = src
      if (integrity)
        nd.setAttribute('integrity', integrity)
    }

    document.head.appendChild(nd)
  }

  // Register components on app instance
  function registerComponents() {
    for (const [comp, def] of window.cpntMap.entries()) {
      aweInstance.component(comp, def)
      cpntMap.delete(comp)
    }
  }

  // returns list of components
  function findComponents(template, parameters, remoteConfig) {
    const components = ['@@LAZY_COMPONENTS']

    const found = new Map()

    for (let i  = 0; i < components.length; i++) {
      const compName = components[i].n

      if (template.includes(`awe-${compName}`)) {

        if (cpntMap.has(`awe-${compName}`) || found.has(compName)) {
          continue
        }

        if (!shouldInclude(compName, parameters, remoteConfig)) {
          stubComponent(compName)
          continue
        }

        if (components[i].d) {

          // include dependencies
          components[i].d.forEach(dep => {
            const depDef = components.find(x => x.n === dep)
            if (!depDef || cpntMap.has(`awe-${dep}`) || found.has(dep))
              return

            if (shouldInclude(dep, parameters, remoteConfig))
              found.set(dep, depDef)
            else
              stubComponent(dep)
          })
        }

        found.set(compName, components[i])
      }
    }

    return Array.from(found.values())
  }

  // function provided to template scripts to register component conditions
  function registerConditions(map) {
    if (!map) return

    for (const [name, fn] of Object.entries(map)) {
      if (typeof fn === 'function')
        cpntConditions[name] = fn
    }
  }

  // Executes the template script
  function loadConditions(content) {
    const run = new Function('registerConditions', content)
    run(registerConditions)
  }

  function shouldInclude(componentName, parameters, remoteConfig) {
    const predicate = cpntConditions[componentName]

    // In studio context, always include all components.
    // Otherwise some options require a full reload if they depend on an ignored component.
    if (!predicate || parameters.renderContext === 'studio')
      return true

    return predicate(parameters, remoteConfig)
  }

  // Empty stand-in so a skipped tag still resolves. inheritAttrs avoids
  // fallthrough warnings, since the stub has no root element.
  function stubComponent(name) {
    cpntMap.set(`awe-${name}`, {
      inheritAttrs: false,
      render: () => null
    })
  }

  // load component scripts
  function loadComponents(comps) {
    const proms = []

    for (let i = 0; i < comps.length; i++) {
      const compName = comps[i].n,
        hash = comps[i].h,
        nd = document.createElement('script')
      nd.src = `components/${compName}/${compName}.js`

      if (hash)
        nd.setAttribute('integrity', `sha384-${hash}`)

      proms.push(new Promise(resolve => {
        nd.onload = resolve
      }))
      document.head.appendChild(nd)
    }

    return Promise.all(proms)
  }

  // sends a message to loader and waits for a response.
  // if no response, we assume postmessage was blocked and safeFrame is enabled.
  function detectSafeFrame() {
    let timeoutId = null;

    const sfDetect = () => {
      clearTimeout(timeoutId)
      timeoutId = null;
    }

    hostCom.send('awe:sfDetect', {}, sfDetect)
    timeoutId = setTimeout(() => {
      if (app.initDone)
        app.setSafeFrame()
      hostCom.off('awe:sfDetect', sfDetect)
    }, 2e3)
  }

  // start init when loader sends widget parameters after widget is loaded
  hostCom.one('awe:initWidget', start)
}()
